/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FileService } from '../../services/file.service';
import { FileInfoSection } from '../../components/file/sections/FileInfoSection';
import { GeneralInfoSection } from '../../components/file/sections/GeneralInfoSection';
import { BrokersSection } from '../../components/file/sections/BrokerSection';
import { CedantsSection } from '../../components/file/sections/CedantSection';
import { SignaturesSection } from '../../components/file/sections/SignatureSection';
import { DynamicSectionRenderer } from '../../components/file/sections/DynamicSectionRenderer';
import { PdfViewer } from '../../components/file/PdfViewer';

export const FileViewerPage = () => {
  const { id } = useParams();
  const [treatyData, setTreatyData] = useState<any>(null);
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      FileService.getTreatyByFileId(id)
        .then((res) => {
          setTreatyData(res.data);
          setTitle(res.data?.file.editedName || res.data?.file.fileName);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Failed to fetch treaty by file ID', err);
          setLoading(false);
        });
    }
  }, [id]);

  const refreshTreatyData = () => {
    if (id) {
      FileService.getTreatyByFileId(id)
        .then((res) => {
          setTreatyData(res.data);
        })
        .catch((err) => {
          console.error('Failed to refresh treaty data', err);
        });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col gap-6 ">
      <div className="flex flex-col gap-6 sm:flex-row">
        <div className="w-full sm:w-2/3">
          <div className="flex items-center justify-center sm:justify-between">
            <h2 className="w-full pb-6 pr-1 text-4xl font-bold text-center break-all whitespace-normal sm:text-left text-primary">
              {title}
            </h2>
          </div>

          {treatyData?.file && (
            <FileInfoSection file={treatyData.file} refreshTreatyData={refreshTreatyData} />
          )}
          {treatyData && (
            <GeneralInfoSection treaty={treatyData} refreshTreatyData={refreshTreatyData} />
          )}
          {treatyData?.brokers && (
            <BrokersSection brokers={treatyData.brokers} refreshTreatyData={refreshTreatyData} />
          )}
          {treatyData?.cedants && (
            <CedantsSection
              cedants={treatyData.cedants}
              treatyId={treatyData.id}
              refreshTreatyData={refreshTreatyData}
            />
          )}
          {treatyData?.signatures && treatyData?.status && (
            <SignaturesSection
              signatures={treatyData.signatures}
              status={treatyData.status}
              refreshTreatyData={refreshTreatyData}
            />
          )}
          {treatyData?.nonProportionalSections && (
            <DynamicSectionRenderer
              sections={treatyData.nonProportionalSections.map((s: any) => ({
                type: 'NON_PROPORTIONAL',
                non_proportional: s,
              }))}
              refreshTreatyData={refreshTreatyData}
            />
          )}

          {treatyData?.proportionalSections && (
            <DynamicSectionRenderer
              sections={treatyData.proportionalSections.map((s: any) => ({
                type: 'PROPORTIONAL',
                proportional: s,
              }))}
              refreshTreatyData={refreshTreatyData}
            />
          )}
        </div>

        <div className="w-full sm:w-1/2">
          <PdfViewer fileId={id!} title={title} />
        </div>
      </div>
    </div>
  );
};
